/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис работы с доступами к устройствам
 */

/**
 * Тип субъекта доступа
 */
export enum DeviceAccessAccessorType {
  /**
   * Значение не указно
   */
  ACCESSOR_TYPE_UNKNOWN = "ACCESSOR_TYPE_UNKNOWN",
  /**
   * ГРуппа
   */
  GROUP = "GROUP",
}
/**
 * Тип субъекта доступа
 */
export type DeviceAccessAccessorTypeResponseEnum = keyof typeof DeviceAccessAccessorType
/**
 * Тип субъекта доступа
 */
export type DeviceAccessAccessorTypeRequestEnum = Exclude<DeviceAccessAccessorTypeResponseEnum, "ACCESSOR_TYPE_UNKNOWN">;

/**
 * Доступ к устройству.
 * # Описание модели
 */
export type DeviceAccessRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  deviceId: number
  /**
   * Тип субъекта доступа
   */
  accessorType: DeviceAccessAccessorTypeRequestEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
}
/**
 * Доступ к устройству.
 * # Описание модели
 */
export type DeviceAccessResponseDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  deviceId: number
  /**
   * Тип субъекта доступа
   */
  accessorType: DeviceAccessAccessorTypeResponseEnum
  /**
   * Идентификатор субъекта доступа.
   * # Диапазон: 1..36
   */
  accessorId: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Доступ к устройству.
   * # Описание модели
   */
  "DeviceAccess": {
    "kind": "class",
    "text": "Доступ к устройству.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 0..2147483647
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип субъекта доступа
       */
      "accessorType": {
        "type": "DeviceAccess.AccessorType",
        "text": "Тип субъекта доступа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор субъекта доступа.
       * # Диапазон: 1..36
       */
      "accessorId": {
        "type": "string",
        "text": "Идентификатор субъекта доступа.\n# Диапазон: 1..36",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 36,
            "message": "Значение не входит в допустимый диапазон. Максимум: 36"
          },
        }
      },
    },
  },
  /**
   * Тип субъекта доступа
   */
  "DeviceAccess.AccessorType": {
    "kind": "enum",
    "text": "Тип субъекта доступа",
    "values": {
      /**
       * Значение не указно
       */
      "ACCESSOR_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указно",
      },
      /**
       * ГРуппа
       */
      "GROUP": {
        "i": 1,
        "text": "ГРуппа",
      },
    },
  },
}